import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContactMessage } from 'src/app/models/ContactMessage';

import { environment } from 'src/environments/environment';

// فرض می‌کنیم این اینترفیس در فایل models/contact-message.model.ts تعریف شده است
// export interface ContactMessage {
//   name: string;
//   email: string;
//   message: string;
// }

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  // private apiUrl = '/api/contact'; // URL پایه بک‌اند
  baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  sendMessage(message: ContactMessage): Observable<any> {
    return this.http.post(`${this.baseUrl}/submit`, message);
  }

  // سرویس برای دریافت پیام‌ها توسط ادمین
  getAdminMessages(): Observable<ContactMessage[]> {
    // این URL باید به endpoint مربوط به ادمین شما در بک‌اند اشاره کند
    // در مثال بالا، مسیر /api/contact/messages بود
    return this.http.get<ContactMessage[]>(`${this.baseUrl}/contact/messages`);
  }

  //  // حذف دستور
  // deleteMe(Id: number): void {
  //   if (confirm("آیا مطمئن هستید که می‌خواهید این دستور را حذف کنید؟")) {
  //     // this.http.delete(`${this.baseUrl}/mythings/${Id}`).subscribe(() => {
  //       // this.http.post(`${this.baseUrl}/mythings/delete`, Id).subscribe(() => {
  //       this.http.post(`${this.baseUrl}/contact/delete/${Id}`, null).subscribe(() => {

  //       // this.getAllcommand(); // بعد از حذف، لیست دستور را مجدد بگیر
  //     });
  //   }
  // }
}
